export default function languageSelect($, apower) {
  //langualge select win
  $.registerComponent("language-win", "win", {
    template: `
		<nav class="win language-win">
			<ul class="win-body">
				<li f-for="item of data" :class="item[0]"><a :href="getURL(item[1])">{{item[3]}}</a></li>
			</ul>
		</nav>
	`,

    data: [
      ["us", "en", "USA", "English"],
      ["fr", "fr", "France", "Français"],
      ["de", "de", "Deutschland", "Deutsch"],
      ["it", "it", "Italia", "Italiano"],
      ["se", "sv", "Sverige", "Svenska"],
      ["nl", "nl", "Nederland", "Nederlands"],
      ["es", "es", "España", "Español"],
      // ["br", "pt", "Brasil", "Português"],
      ["fi", "fi", "Suomi", "Suomi"],
      ["no", "no", "Norge", "Norsk"],
      ["dk", "da", "Danmark", "Dansk"],
      ["tr", "tr", "Türkiye", "Türkçe"],
      ["pl", "pl", "Polska", "Polski"],
      ["jp", "ja", "日本", "日本語"],
      ["tw", "tw", "中國台灣", "繁體中文"],
      ["cn", "zh", "中国", "简体中文"],
      ["hu", "hu", "Magyarországon", "Magyar"],
      ["cz", "cs", "Čeština", "Čeština"],
      ["gr", "el", "Ελλάδα", "ελληνικά"],
      ["pt", "pt", "Portugal", "Português"],
      ["kr", "kr", "kr", "한국어"],
      ["ar", "ar", "العربية", "عربي"],
      // ['ru' , 'ru' , 'Россия'         , 'Русский']   ,
      // ['id' , 'id' , 'Indonesia'      , 'Indonesia'] ,
      // ['in' , 'in' , 'Hindustan'      , 'Hindi']     ,
    ],

    autoDestroy: true,

    target: "body",

    onCreated() {
      this.apower = apower;
    },

    getURL(lang) {
      return apower.getDomain(lang);
    },
  });

  $.registerComponent("language-select", {
    template: `
		<div class="language-select" @click="openWin">
			<div class="language-select-flag"></div>
			<div class="language-select-name"></div>
			<icon type="up"></icon>
		</div>
	`,

    openWin() {
      $.newComponent("language-win").show();
    },
  });
}
